

import * as React from 'react';
import { useState } from 'react';

import Button from '@mui/material/Button';

import { FilePreviewIcon } from './FilePreviewIcon';
import { validateFileSizeLimit } from '../Helper/utils';
import { ToastEmitter } from '../ToastEmitter';
import { VisuallyHiddenInput } from "../StyledComponent"
import { EXCEED_SIZE_LIMIT } from '../constant';

export const DocumentFileUpload = ({ field, setValue, name }) => {
  const [selected , setSelected] = useState(field.value);
  const [currentFile, setCurrentFile]= useState();
  const fileSelectedHandler = (event) => {
    const file = event.target.files[0];
    if (!validateFileSizeLimit(file, 2)) {
      ToastEmitter(EXCEED_SIZE_LIMIT, "error");
      return;
    }
    setCurrentFile([file]);
    event.target.value = null;
  };

  return (
    <>
    <div className="flex flex-row  flex-wrap gap-2 p-2 " style={{ width: 'fit-content', height: 'fit-content', gap: '2rem'}}>
    <div className="flex  border border-solid rounded-xl border-[#DBE0E6]   justify-center" style={{ width: 'fit-content' }}>

    <Button
    className='border-[#70829B] bg-white  border-2  rounded-full flex flex-col justify-center items-center fit-content'
      component="label"
      style={{ width: '8.75rem', height: '8.75rem' }}
      variant=""
    >
      <img src="https://views.medibuddy.in/providerUi/assets/DoctorUpload.svg" alt="" className="flex justify-enter" />
      <p className="text-sm font-normal text-[#70829B]" style={{textAlign:'center' }}> Upload Image</p>
     
      <VisuallyHiddenInput
        type="file"
        accept="image/png, image/jpeg, image/jpg"
        onChange={(event)=>(fileSelectedHandler(event))}
        
      />
    </Button>
    </div>
    <FilePreviewIcon currentFile={currentFile} setCurrentFile={setCurrentFile} selectedFile={selected} setSelectedFile={setSelected} setValue={setValue} name={name} />
    </div>
    </>
  );
}
